import React, { useMemo } from 'react'
import {
  getCheckInDateFromURLSearchParams,
  getCheckOutDateFromURLSearchParams,
  getPriceLteFromURLSearchParams,
} from 'lib/url/searchUrlUtils'
import useQueryParams from 'hooks/useQueryParams'
import RadioGroup from 'LuxKit/Radio/RadioGroup'
import RadioInput from 'LuxKit/Radio/RadioInput'
import { connect } from 'react-redux'
import { generatePriceFilterOptions, SHOW_ALL_BUDGET } from 'businessTraveller/utils/generatePriceFilterOptions'

interface MappedStateProps {
  currentBudget: App.BusinessTraveller.BusinessBudget | undefined,
}

interface Props {
  search: string;
  onChange: (value: string) => void;
}

function BusinessTravellerWithinBudgetMapFilter(props: Props & MappedStateProps) {
  const { currentBudget, onChange } = props
  const queryParams = useQueryParams()

  const { checkInDate, checkOutDate, priceLte } = useMemo(() => {
    return {
      checkInDate: getCheckInDateFromURLSearchParams(queryParams),
      checkOutDate: getCheckOutDateFromURLSearchParams(queryParams),
      priceLte: getPriceLteFromURLSearchParams(queryParams),
    }
  }, [queryParams])

  const selectedBudget = priceLte?.toString() ?? SHOW_ALL_BUDGET

  const budgetFilterOptions = useMemo(() => generatePriceFilterOptions(checkInDate, checkOutDate, currentBudget), [checkInDate, checkOutDate, currentBudget])

  return (
    <RadioGroup disabled={!currentBudget}>
      {budgetFilterOptions.map(option => (
        <RadioInput
          key={option.label}
          name={option.label}
          value={option.value}
          checked={!!option.value && option.value === selectedBudget}
          onChange={() => onChange(option.value)}
          disabled={!currentBudget}
        >
          {option.label}
        </RadioInput>
      ))}
    </RadioGroup>
  )
}

const mapStateToProps = (state: App.State) => {
  return {
    currentBudget: state.businessTraveller.businessMapBudget,
  }
}

export default connect(mapStateToProps)(BusinessTravellerWithinBudgetMapFilter)
